import moment from "moment-timezone";
import GameGroupMethods from 'utils/game-group-methods.js'

const gameGroupMethods = new GameGroupMethods()
export default {
  methods: {
    defaultPeriod (item, catenaId) { // 預設當期期數, 預開下期期數
      const defaultBalls = Array.from({ length: gameGroupMethods.items[catenaId].balls }, (v, i) => '-')
      let result = { //预设放最新的期数
        GPMId: '*',
        period: item.listPeriodData.lastperiod,
        date: item.listPeriodData.lastdate,
        endate: item.listPeriodData.lastendate,
        codate: item.listPeriodData.lastcodate,
        rtp: null,
        mark: defaultBalls
      }
      item.listPeriodData.second ? result['second'] = item.listPeriodData.second : null
      if (!this.filterTimeOut(result)) { // 判斷最新是否已經逾時了, 放入预开期数
        const date = item.listPeriodData.lastperiod.slice(0, 8)
        if (item.listPeriodData.length == 8 && item.listPeriodData.betSeconds >= 25200) {
          const enddatetime = moment(item.listPeriodData.lastendate).format('HH:mm:ss')
          const datetime = moment(item.listPeriodData.lastdate).format('HH:mm:ss')
          result.period = moment(date).add(1, 'days').format('YYYYMMDD')
          result.date = moment(date).add(1, 'days').format(`YYYY-MM-DD ${datetime}`)
          result.endate = moment(date).add(1, 'days').format(`YYYY-MM-DD ${enddatetime}`)
          result.codate = moment(result.endate).subtract(15, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        }
        let period = Number(item.listPeriodData.lastperiod) + 1
        let plusSeconds = item.listPeriodData.betSeconds * 1000
        let lastdateValue = moment(item.listPeriodData.lastdate).valueOf() + plusSeconds // 計算預計開盤時間
        let lastendateValue = moment(item.listPeriodData.lastendate).valueOf() + plusSeconds // 計算預計開獎時間
        let lastcodateValue = moment(item.listPeriodData.lastcodate).valueOf() + plusSeconds // 計算預計開獎時間

        result.period = period
        result.date = moment(lastdateValue).format('YYYY-MM-DD HH:mm:ss')
        result.endate = moment(lastendateValue).format('YYYY-MM-DD HH:mm:ss')
        result.codate = moment(lastcodateValue).format('YYYY-MM-DD HH:mm:ss')
      }
      return result
    },
    filterTimeOut (it, index) { // 移除時間逾時狀態
      // let now = moment(moment.tz('Asia/Hong_Kong').format("YYYY-MM-DD H:mm:ss")).valueOf()
      let now = moment(moment.tz('Asia/Hong_Kong').format("YYYY-MM-DD H:mm:ss")).valueOf()
      if (it.period.length != 8) {
        let enTime = moment(new Date(it.codate)).valueOf();
        let subTime = moment.tz(enTime - now, "Africa/Abidjan")
        return moment(subTime).valueOf() > 0
      } else {
        // 判斷 日開彩跨日才新增期數，否則都是不新增狀態
        if (moment(now).format("YYYY-MM-DD") > moment(it.date).format("YYYY-MM-DD")) return false
        return true
      }

    },
  }
}